import { initializeApp } from "firebase/app"

import { getAnalytics } from "firebase/analytics"
import { useEffect } from "react"
import { HOST_FIREBASE_CONFIG } from "@/globalConfig"

const FirebaseSDK = () => {
  
  useEffect(() => {
    if (Object.keys(HOST_FIREBASE_CONFIG).length > 0) {
      const app = initializeApp(HOST_FIREBASE_CONFIG)
      const analytics = getAnalytics(app)
    }
  }, [])
  return <></>
}

export default FirebaseSDK
